import { render, staticRenderFns } from "./MedicalSpecialityForm.vue?vue&type=template&id=8704eb16&scoped=true"
import script from "./MedicalSpecialityForm.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialityForm.vue?vue&type=script&lang=js"
import style0 from "./MedicalSpecialityForm.vue?vue&type=style&index=0&id=8704eb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8704eb16",
  null
  
)

export default component.exports